import React from 'react';
import moment from 'moment';

// get value from configColors
export const getValue = (configColors, sectionId, titleId) => {
  if (!configColors) return configColors.primary;
  if (!configColors.config) return configColors.primary;
  const section = configColors.config.find(
    (section) => section.sectionId === sectionId
  );
  if (section === undefined) return configColors.primary;
  const title = section.values.find((title) => title.id === titleId);
  return title?.value;
};

// get cookies
export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2)
    return parts
      .pop()
      .split(';')
      .shift();
};

// set cookies
export const setCookie = (name, value, days) => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000); // 24 hours
    expires = `; expires=${date.toGMTString()}`;
  }
  document.cookie = `${name}=${value}${expires}; path=/;SameSite=none;`;
};

// delete cookies
export const deleteCookie = (name) => {
  document.cookie = `${name}=; Max-Age=-99999999;`;
};

// Render escaped string
export const RenderEscapedString = (text) => {
  if (!text) return null;
  const tabReplacedText = text.replace(/\t/g, '    ');
  const newText = tabReplacedText.split('\n').map((item, index, array) => (
    <React.Fragment key={index}>
      {item}
      {index !== array.length - 1 && <br />}
    </React.Fragment>
  ));

  return <>{newText}</>;
}

export const generateRandomId = () => {
  return (
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15)
  );
};

export const formatTime = (totalMinutes) => {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  let timeString = '';
  if (hours > 0) {
    timeString += `${hours}h`;
  }
  if (minutes > 0) {
    timeString += ` ${minutes} min`;
  }
  if (timeString === '') {
    timeString = '0';
  }
  return timeString;
};

export const formatDate = (dateTimeStr) => {
  const date = moment(dateTimeStr);

  if (date.isSame(moment(), 'day')) {
    return `Today ${date.format('HH:mm')}`;
  } else if (date.isSame(moment().subtract(1, 'day'), 'day')) {
    return `Yesterday ${date.format('HH:mm')}`;
  } else {
    return date.format('dddd, MMMM D, YYYY HH:mm');
  }
};

export const formatDateDifference = (dateString) => {
  const date = moment.parseZone(dateString);
  const now = moment();
  const diffDays = now.diff(date, 'days');

  let relativeTime;

  if (diffDays === 0) {
    relativeTime = `Today at ${date.format('h:mm A')}`;
  } else if (diffDays === 1) {
    relativeTime = `Yesterday at ${date.format('h:mm A')}`;
  } else {
    relativeTime = `${diffDays} days ago at ${date.format('h:mm A')}`;
  }

  return relativeTime;
};

export const renderFileIcon = (type) => {
  const iconClassList = {
    'application/pdf': 'fa fa-file-pdf-o',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'fa fa-file-word-o',
    'application/zip': 'fa fa-file-zip-o',
    'text/csv': 'fa fa-file-text',
    'text/plain': 'fa fa-file-text',
    'image/png': 'fa fa-file-image-o',
    'image/jpeg': 'fa fa-file-image-o',
    'image/jpg': 'fa fa-file-image-o',
    "image/gif": 'fa fa-file-image-o',
  }
  return iconClassList[type];
}

export const materialName = {
  paths: "Path",
  walkthrough: "Walkthrough",
  video: "Video",
  docs: "Docs"
};